export const Definer = {
  general_err1:"att: Something went wrong",
  input_err1: "att: Please fulfill all inputs",
  input_err2: "att: Please insert valid type of image",
  input_err3: "att: Message is empty",
  input_err4: "att: Please add your shipping address",
  auth_err1: "att: Please login first",
};
